import api from "utils/api";
import endpoint from "utils/endpoint";
import { JobFeedStatus, JobType, SalaryType } from "domain/model/JobFeed";

class JobFeedRepository {
  create(
    isAgency: boolean,
    storeId: string | undefined,
    {
      status,
      title,
      company,
      jobType,
      description,
      postDate,
      salaryType,
      salaryMin,
      salaryMax,
      zipCode,
      state,
      city,
      address,
      station,
      experience,
      workingTime,
      holiday,
      benefits,
      insurance,
      preventSmoke,
      contractPeriod,
      url,
      imageUrl,
      companyUrl,
      companyLogoUrl,
      pageHeader,
      pageFooter,
    }: {
      status: JobFeedStatus;
      title: string;
      company: string;
      jobType: JobType;
      description: string;
      postDate: Date;
      salaryType: SalaryType;
      salaryMin: number;
      salaryMax: number;
      zipCode: string | null;
      state: string;
      city: string;
      address: string | null;
      station: string | null;
      experience: string | null;
      workingTime: string | null;
      holiday: string | null;
      benefits: string | null;
      insurance: string | null;
      preventSmoke: string | null;
      contractPeriod: string | null;
      url: string | null;
      imageUrl: string | null;
      companyUrl: string | null;
      companyLogoUrl: string | null;
      pageHeader: string | null;
      pageFooter: string | null;
    }
  ) {
    const rqUrl =
      isAgency && storeId
        ? endpoint.agency.jobFeed.feeds(storeId)
        : endpoint.store.jobFeed.feeds();

    const body = {
      job_feed: {
        status: status,
        title: title,
        company: company,
        job_type: jobType,
        description: description,
        post_date: postDate,
        salary_type: salaryType,
        salary_min: salaryMin,
        salary_max: salaryMax,
        zip_code: zipCode === "" ? null : zipCode,
        state: state,
        city: city,
        address: address === "" ? null : address,
        station: station === "" ? null : station,
        experience: experience === "" ? null : experience,
        working_time: workingTime === "" ? null : workingTime,
        holiday: holiday === "" ? null : holiday,
        benefits: benefits === "" ? null : benefits,
        insurance: insurance === "" ? null : insurance,
        prevent_smoke: preventSmoke === "" ? null : preventSmoke,
        contract_period: contractPeriod === "" ? null : contractPeriod,
        url: url === "" ? null : url,
        image_url: imageUrl === "" ? null : imageUrl,
        company_url: companyUrl === "" ? null : companyUrl,
        company_logo_url: companyLogoUrl === "" ? null : companyLogoUrl,
        page_header: pageHeader === "" ? null : pageHeader,
        page_footer: pageFooter === "" ? null : pageFooter,
      },
    };
    return api.post(rqUrl, body).then((res) => res.data);
  }

  update(
    isAgency: boolean,
    storeId: string | undefined,
    feedId: string,
    {
      status,
      title,
      company,
      jobType,
      description,
      postDate,
      salaryType,
      salaryMin,
      salaryMax,
      zipCode,
      state,
      city,
      address,
      station,
      experience,
      workingTime,
      holiday,
      benefits,
      insurance,
      preventSmoke,
      contractPeriod,
      url,
      imageUrl,
      companyUrl,
      companyLogoUrl,
      pageHeader,
      pageFooter,
    }: {
      status: JobFeedStatus;
      title: string;
      company: string;
      jobType: JobType;
      description: string;
      postDate: Date;
      salaryType: SalaryType;
      salaryMin: number;
      salaryMax: number;
      zipCode: string | null;
      state: string;
      city: string;
      address: string | null;
      station: string | null;
      experience: string | null;
      workingTime: string | null;
      holiday: string | null;
      benefits: string | null;
      insurance: string | null;
      preventSmoke: string | null;
      contractPeriod: string | null;
      url: string | null;
      imageUrl: string | null;
      companyUrl: string | null;
      companyLogoUrl: string | null;
      pageHeader: string | null;
      pageFooter: string | null;
    }
  ) {
    const rqUrl =
      isAgency && storeId
        ? endpoint.agency.jobFeed.feed(storeId, feedId)
        : endpoint.store.jobFeed.feed(feedId);
    const body = {
      job_feed: {
        status: status,
        title: title,
        company: company,
        job_type: jobType,
        description: description,
        post_date: postDate,
        salary_type: salaryType,
        salary_min: salaryMin,
        salary_max: salaryMax,
        zip_code: zipCode === "" ? null : zipCode,
        state: state,
        city: city,
        address: address === "" ? null : address,
        station: station === "" ? null : station,
        experience: experience === "" ? null : experience,
        working_time: workingTime === "" ? null : workingTime,
        holiday: holiday === "" ? null : holiday,
        benefits: benefits === "" ? null : benefits,
        insurance: insurance === "" ? null : insurance,
        prevent_smoke: preventSmoke === "" ? null : preventSmoke,
        contract_period: contractPeriod === "" ? null : contractPeriod,
        url: url === "" ? null : url,
        image_url: imageUrl === "" ? null : imageUrl,
        company_url: companyUrl === "" ? null : companyUrl,
        company_logo_url: companyLogoUrl === "" ? null : companyLogoUrl,
        page_header: pageHeader === "" ? null : pageHeader,
        page_footer: pageFooter === "" ? null : pageFooter,
      },
    };
    return api.put(rqUrl, body).then((res) => res.data.job_feed);
  }

  toggle(isAgency: boolean, storeId: string | undefined, feedId: string) {
    const url =
      isAgency && storeId
        ? endpoint.agency.jobFeed.toggle(storeId, feedId)
        : endpoint.store.jobFeed.toggle(feedId);
    return api.post(url).then((res) => res.data);
  }

  delete(isAgency: boolean, storeId: string | undefined, feedId: string) {
    const url =
      isAgency && storeId
        ? endpoint.agency.jobFeed.feed(storeId, feedId)
        : endpoint.store.jobFeed.feed(feedId);
    return api.delete(url).then((res) => res.data);
  }
}

export default new JobFeedRepository();
